module.exports = __webpack_public_path__ + "img/pro-5-gen-portrait-solid.8b91f65.jpg";